import React from 'react';
import Layout from "@src/layout";
import ReactHotToast from "@src/components/UIElements/ReactHotToast";
import BottomSheets from "@src/components/BottomSheets";
import { getDefaultLanguage, getUserToken } from "@src/utils/getAxiosConfig";
import { DEFAULT_APP_ACCENT_COLOR, setAppConfig } from "@root/store/persistedData";
import { useDispatch, useSelector } from "react-redux";
import { getOrgDetailsAction, getUserDetailsAction } from '@src/components/Tabs/Overview/store/actions';
// import { selectDefaultLanguageFromOrgDetails } from '@root/store/selectors';
import { setFont } from '@src/utils';
import i18next from "i18next";
import cssVars from "css-vars-ponyfill";

const AppComponent = ({ layoutProps, pageProps, children }) => {

    // REDUX DISPATCH
    const dispatch = useDispatch();

    // REF FOR LOTTIE TIMEOUT
    const polyfillTimerRef = React.useRef();

    // FETCHING APP ACCENT COLOR FROM REDUX
    const appAccent = useSelector(
        (state) => state?.persistedDataReducer?.appAccent
    );

    // const defaultLanguageFromOrgDetails = useSelector(selectDefaultLanguageFromOrgDetails)

    React.useEffect(() => {
        setAppConfig();
        dispatch(getOrgDetailsAction());
        const userToken = getUserToken();
        if (userToken) {
            dispatch(getUserDetailsAction());
        }

        // JUST A CONSOLE LOG DENOTING WEBVIEW HAS LAUNCHED
        console.log("******************* COURSE WEBVIEW LAUNCHED ************************");

        // I18NEXT CHANGE LANGUAGE
        const defaultLanguage = getDefaultLanguage();
        if (defaultLanguage && defaultLanguage?.toLowerCase() != "en") {
            i18next.changeLanguage(defaultLanguage.toLowerCase());
        }

        // IMPORTANT NOTE FOR APP ACCENT COLOR USAGE
        // DEFAULT CLASSPLUS BLUE COLOR IF NO ACCENT COLOR
        // APP ACCENT COLOR CAN BE USED AD
        // var(--appAccentColor) **** in css
        // $color-app-accent **** in scss (main.scss imported)
        cssVars({
            variables: {
                "--appAccentColor": `#${new URLSearchParams(window?.location?.search).get("color") || DEFAULT_APP_ACCENT_COLOR}`,
            }
        })
    }, [])

    React.useEffect(() => {
      const defaultLanguage = getDefaultLanguage();
      setFont(defaultLanguage)
    //   setFont(defaultLanguage || defaultLanguageFromOrgDetails)
    }, []);
    // }, [defaultLanguageFromOrgDetails]);

    return (
        <div
            id="appWrapper"
            style={{
                "--appAccentColor": `#${appAccent || DEFAULT_APP_ACCENT_COLOR}`,
            }}
        >
            <Layout layoutProps={layoutProps} pageProps={pageProps}>
                {children}
            </Layout>
            <ReactHotToast />
            <BottomSheets />
        </div>
    );
};

export default AppComponent;